import { render, staticRenderFns } from "./BidsListFilters.vue?vue&type=template&id=cebdef0a"
import script from "./BidsListFilters.vue?vue&type=script&lang=js"
export * from "./BidsListFilters.vue?vue&type=script&lang=js"
import style0 from "./BidsListFilters.vue?vue&type=style&index=0&id=cebdef0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports